import { render, staticRenderFns } from "./SortByMenuCustomsDashboard.vue?vue&type=template&id=5c2f93a7&"
import script from "./SortByMenuCustomsDashboard.vue?vue&type=script&lang=js&"
export * from "./SortByMenuCustomsDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c2f93a7')) {
      api.createRecord('5c2f93a7', component.options)
    } else {
      api.reload('5c2f93a7', component.options)
    }
    module.hot.accept("./SortByMenuCustomsDashboard.vue?vue&type=template&id=5c2f93a7&", function () {
      api.rerender('5c2f93a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/invoices/SortByMenuCustomsDashboard.vue"
export default component.exports